import Avatar from "@/atoms-react/avatar/Avatar.react";
import { Base } from "@/atoms-react/text/Text.react";
import { EmptyPageCactusAnimation } from "@/components/animations/empty-cactus/index.react";
import { RCSRepresentative } from "@/features/company/types";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

type RepresentativeType = RCSRepresentative;

type AddCompanyDetectRepresentativeProps = {
  onValidate: (representativeSelected: RepresentativeType | null) => void;
  representativeData: RepresentativeType[];
  loading: boolean;
};

export const AddCompanyDetectRepresentative = ({
  onValidate,
  representativeData,
  loading = false
}: AddCompanyDetectRepresentativeProps) => {
  const { t } = useTranslation(["pass"]);
  return (
    <div className="flex flex-row justify-center md:px-6 md:py-6">
      <div className="flex flex-col justify-center">
        <Base className="text-center text-sm md:px-12">
          {t("olkypass.companyPage.company_detection.text-1")}{" "}
        </Base>
        <Base className="mt-4 text-center text-sm md:px-12">
          {t("olkypass.companyPage.company_detection.text-2")}{" "}
        </Base>
        <div className="radius-sm mt-6 rounded-sm border-2">
          <ul className="h-auto h-max-[500px] overflow-y-auto rounded-sm">
            {representativeData.length === 0 ? (
              <div className="flex h-full flex-row justify-center py-14">
                <div className="flex h-max flex-col justify-center">
                  <EmptyPageCactusAnimation />{" "}
                </div>
              </div>
            ) : (
              representativeData?.map((representativeItem, representativeIndex) => (
                <li className="border-b-1" key={representativeIndex}>
                  <div className="flex flex-row justify-between px-2 py-4">
                    <div className="flex">
                      <div className="hidden sm:block">
                        <Avatar
                          size={10}
                          fallback={`${representativeItem.first_name}  ${representativeItem.last_name}`}
                        />{" "}
                      </div>
                      <div className="flex flex-col justify-center">
                        <Base className="ml-2 text-sm md:text-base">{`${representativeItem.first_name}  ${representativeItem.last_name}`}</Base>{" "}
                      </div>
                    </div>
                    <div className="flex cursor-pointer flex-col justify-center">
                      <div className="flex flex-col justify-center text-right">
                        <a
                          onClick={() => {
                            if (!loading) onValidate(representativeItem);
                          }}
                        >
                          <Base
                            className={twMerge(
                              "text-blue-500 text-sm underline",
                              loading && "text-gray-600"
                            )}
                            disabled={loading}
                          >
                            {t("olkypass.companyPage.company_detection.text-3")}{" "}
                          </Base>
                        </a>
                      </div>
                    </div>
                  </div>
                </li>
              ))
            )}
          </ul>
        </div>
        <div
          className="mt-8 flex w-full cursor-pointer flex-row justify-center"
        >
          <a
            onClick={() => {
              if (!loading) onValidate(null);
            }}
          >
            <Base
              className={twMerge("text-blue-500 text-sm underline", loading && "text-gray-600")}
              disabled={loading}
            >
              {t("olkypass.companyPage.company_detection.text-4")}{" "}
            </Base>
          </a>
        </div>
      </div>
    </div>
  );
};
